// apiActions.js

import axios from 'axios';
import { ACCEPTED_API, AGREEMENT_API, APPROVE_CUSTOMER_API, B2B_ONBOARDING_SUBMIT_API, BUSINESS_TYPE_API, CREATE_CUSTOMER_USER, CREATE_PARTNERS, CREATE_SINGLE_CUSTOMER_USER, CREATE_STAFF_USER, CREATE_V2PRM_API, CUSTOMER_LOGIN_API, CUSTOMER_LOGIN_OTP_API, DELETE_CUSTOMER_USER, DETAILS_API, DOWNLOAD_REQUEST_API, EXPORT_DATA_API, GENERATE_REPORT_API, GET_IDENTITY_DETAILS_API, GET_KYC_REQUESTS, GET_SIP_SELLER_DATA, IFSC_API, LOGIN_API, MAIL_SENT_API, ONBOARD_NEW_CUSTOMER_API, OnboardingAPI, PARTNER_BANK_API, PENDING_API, PHONE_VALIDATE_API, PROGRAM_API, REFRESH_TOKEN_STAFF, REINITIATE_KYC_REQUEST, REJECTION_HISTORY_API, REJECT_CUSTOMER_API, RESEND_CODE, RESEND_EMAIL_API, STEP_FIVE_API, STEP_TWO_API, STEP_TWO_WITHOUT_FILE_API, UPDATE_BANK_DETAILS_API, UPDATE_BUSINESS_TYPE_API, UPDATE_DECLARATION, UPDATE_HDFC_API, UPDATE_LAST_STEP, UPDATE_PHONE_EMAIL_API, UPDATE_TRUST_NUMBER, UPDATE_V2P_API, V2P_RM_API, VALIDATE_PAN_GSTIN_API, VERIFY_BANK_DETAILS_API, VERIFY_CIN } from '../Constants';
import { startLoading } from './loadingReducer';
import showNotification from './NotifcationService';
import { LoginUser, UpdateTokenChr } from './LoginReducer';
import { jwtDecode } from "jwt-decode";
import { CUSTOMER_USER_SUBMIT } from './../Constants';

function compileErrors(err) {
    var commonErrMsg = "Something went wrong!!! Please try again in sometime";
    var msg = "";

    if (err && "exceptionMessage" in err) {
        var exp = err.exceptionMessage;

        if (typeof exp === "object") {
            if (exp && "errors" in exp) {
                var expErr = exp.errors;

                if (typeof expErr === "object") {
                    for (var key in expErr) {
                        if (expErr.hasOwnProperty(key)) {
                            var val = expErr[key];

                            if (typeof val === "object" || Array.isArray(val)) {
                                for (var key1 in val) {
                                    if (val.hasOwnProperty(key1)) {
                                        var val1 = val[key1];
                                        msg += (val1 != null && typeof val1 === "string") ? (val1 + ", ") : "";
                                    }
                                }
                            } else {
                                msg += (val != null && typeof val === "string") ? (val + ", ") : "";
                            }
                        }
                    }
                } else {
                    msg += (expErr != null && typeof expErr === "string") ? (expErr + ", ") : "";
                }
            }
        } else {
            msg += (exp != null && typeof exp === "string") ? (exp + ", ") : "";
        }
    }

    msg = msg.trim();
    msg = msg.replace(/,(?=\s*$)/, '');

    return msg === "" ? commonErrMsg : msg;
}


export const tokenService = async (token, dispatch) => {
    let decodedToken = jwtDecode(token);
    // console.log("Decoded Token", decodedToken);
    let currentDate = new Date();

    // JWT exp is in seconds
    if (decodedToken.exp * 1000 < currentDate.getTime()) {
        // console.log("Token expired.");
        try {
            dispatch(startLoading(true));
            const payload = {
                'accessToken': token,
                'refreshToken': 'refreshToken'
            };
            const headers = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': "http://127.0.0.1:3000"
            };
            const response = await axios.post(REFRESH_TOKEN_STAFF, payload, { headers });
            await dispatch(UpdateTokenChr(response?.data.result));
            return response?.data.result.token_chr; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
            throw error; // Re-throw the error to handle it in the caller function
        } finally {
            dispatch(startLoading(false));
        }
    } else {
        // console.log("Valid token");
        return token;
    }
};

export const refreshTokenCall = (payload, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': "http://127.0.0.1:3000"
            };
            const response = await axios.post(REFRESH_TOKEN_STAFF, payload, { headers });
            await dispatch(UpdateTokenChr(response?.data.result));
            return response?.data.result; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
            throw error; // Re-throw the error to handle it in the caller function
        } finally {
            dispatch(startLoading(false));
        }
    }
}
export const login = (data) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': "http://127.0.0.1:3000"
            };

            const response = await axios.post(LOGIN_API, data, { headers });
            await dispatch(LoginUser(response?.data.result))
            return response?.data.result; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
            window?.grecaptcha?.reset();
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};

export const MailSentApi = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
                // 'Authorization': `Bearer ${token}`
            };

            const response = await axios.post(MAIL_SENT_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const PendingDataApi = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(PENDING_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const AcceptedDataApi = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(ACCEPTED_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const v2pRMApi = (token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.get(V2P_RM_API, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};

export const getRejectedHistory = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(REJECTION_HISTORY_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};

export const getAgreementData = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(AGREEMENT_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};

export const createV2PRMApi = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(CREATE_V2PRM_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const downloadRequest = (token, blob_id) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.get(`${DOWNLOAD_REQUEST_API}?blobId=${blob_id}`, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const reinitiateKycRequest = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(REINITIATE_KYC_REQUEST, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const getKycRequestListApi = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(GET_KYC_REQUESTS, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const getPartnerBank = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(PARTNER_BANK_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const getPartnerData = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(PROGRAM_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const ExportDataApi = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(EXPORT_DATA_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const ResendEmailApi = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(RESEND_EMAIL_API, data, { headers });
            if (response?.data.statusText === "Ok") {
                showNotification("Email Re-Sent SuccessFully", 'success');
            }
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const UpdateV2PRMApi = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(UPDATE_V2P_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const UpdateHDFCRMApi = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(UPDATE_HDFC_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const UpdatePhoneEmailApi = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(UPDATE_PHONE_EMAIL_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const CreateCustomerApi = (data, token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.post(ONBOARD_NEW_CUSTOMER_API, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data?.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const CreateStaffUser = (data, token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token_chr, dispatch)}`
            };

            const response = await axios.post(CREATE_STAFF_USER, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data?.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const DetailsApi = (data, token_chr, customer) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${customer === 'customer' ? token_chr : await tokenService(token_chr, dispatch)}`
            };

            const response = await axios.post(DETAILS_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data?.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const ValidatePhoneApi = (data, token_chr, customer) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${customer === 'customer' ? token_chr : await tokenService(token_chr, dispatch)}`
            };

            const response = await axios.post(PHONE_VALIDATE_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data?.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const BusinessTypeApi = (data, token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token_chr, dispatch)}`
            };

            const response = await axios.post(BUSINESS_TYPE_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data?.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const UpdateBusinessTypeApi = (data, token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token_chr, dispatch)}`
            };

            const response = await axios.post(UPDATE_BUSINESS_TYPE_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data?.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const RejectCustomerApi = (data, token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token_chr, dispatch)}`
            };

            const response = await axios.post(REJECT_CUSTOMER_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data?.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const ApproveCustomerApi = (data, token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token_chr, dispatch)}`
            };

            const response = await axios.post(APPROVE_CUSTOMER_API, data, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data?.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const customerLoginApi = (data) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
            };

            const response = await axios.post(CUSTOMER_LOGIN_API, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
            window?.grecaptcha?.reset();
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const customerVerifyOtpApi = (data) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
            };

            const response = await axios.post(CUSTOMER_LOGIN_OTP_API, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
            window?.grecaptcha?.reset();
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const validateGstinPan = (data, token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(VALIDATE_PAN_GSTIN_API, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const stepTwoApiCall = (data, token_chr, sez, custId) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(`${STEP_TWO_API}?SEZ=${sez}&custId=${custId}`, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const stepTwoWithoutFileApiCall = (data, token_chr, custId) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(`${STEP_TWO_WITHOUT_FILE_API}?custId=${custId}`, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};

export const verifyCIN_Api_Call = (data, token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(VERIFY_CIN, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const updateTrustNumberCall = (data, token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(UPDATE_TRUST_NUMBER, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};

export const updateLastStep = (data, token_chr, custId) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(`${UPDATE_LAST_STEP}?step=${3}&custId=${custId}`, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const step5Call = (data, token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(STEP_FIVE_API, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const createPartnersCall = (data, token_chr, custId) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(`${CREATE_PARTNERS}?custId=${custId}`, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {

            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const createCustomerUserCall = (data, token_chr, custId) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(`${CREATE_CUSTOMER_USER}?customerId=${custId}`, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {

            showNotification(compileErrors(error.response?.data.error), 'error');

        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const updateDeclaration = (data, token_chr, custId) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(UPDATE_DECLARATION, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {

            showNotification(compileErrors(error.response?.data.error), 'error');

        }
        finally {
            dispatch(startLoading(false));
        }
    };
};

export const resendOTP = (userId) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
            };

            const response = await axios.get(`${RESEND_CODE}?UserId=${userId}&module=Login OTP&IsResend=true`, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {

            showNotification(compileErrors(error.response?.data.error), 'error');

        }
        finally {
            dispatch(startLoading(false));
        }
    };
};

export const createSingleCustomerUserCall = (data, token_chr, custId) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(`${CREATE_SINGLE_CUSTOMER_USER}?CustomerId=${custId}`, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {

            showNotification(compileErrors(error.response?.data.error), 'error');

        }
        finally {
            dispatch(startLoading(false));
        }
    };
};

export const customerUserSubmitCall = (data, token_chr, custId) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(`${CUSTOMER_USER_SUBMIT}?customerId=${custId}`, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {

            showNotification(compileErrors(error.response?.data.error), 'error');

        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const deleteCustomerUser = (data, token_chr, userId) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.post(`${DELETE_CUSTOMER_USER}?Id=${userId}`, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {

            showNotification(compileErrors(error.response?.data.error), 'error');

        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const getIfscData = (Ifsc,token_chr) => {
    return async (dispatch) => {
        dispatch(startLoading(true));
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };

            const response = await axios.get(`${IFSC_API}?ifsc=${Ifsc}`, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const addUpdateCustomerBankData = (data,token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };
            
            const response = await axios.post(UPDATE_BANK_DETAILS_API, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {

            showNotification(compileErrors(error.response?.data.error), 'error');

        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const verifyBankDetails = (data,token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };
            
            const response = await axios.post(VERIFY_BANK_DETAILS_API, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {

            showNotification(compileErrors(error.response?.data.error), 'error');

        }
        finally {
            dispatch(startLoading(false));
        }
    };
};

export const getEntityDetailsApi = (data,token_chr) => {
    return async (dispatch) => {
        dispatch(startLoading(true));
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };
            
            const response = await axios.get(`${GET_IDENTITY_DETAILS_API}?customerId=${data}`, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {

            showNotification(compileErrors(error.response?.data.error), 'error');

        }
        finally {
            dispatch(startLoading(false));
        }
    };
};

export const B2BOnBoardingSubmitApi = (data,token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };
            
            const response = await axios.post(B2B_ONBOARDING_SUBMIT_API, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {

            showNotification(compileErrors(error.response?.data.error), 'error');

        }
        finally {
            dispatch(startLoading(false));
        }
    };
};
export const GenerateReportApiCall = (data,token_chr) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token_chr}`
            };
            
            const response = await axios.post(GENERATE_REPORT_API, data, { headers });

            return response?.data; // Return the response data to the component if needed
        } catch (error) {

            showNotification(compileErrors(error.response?.data.error), 'error');

        }
        finally {
            dispatch(startLoading(false));
        }
    };
};


export const getSIPSellerData = (token) => {
    return async (dispatch) => {
        try {
            dispatch(startLoading(true));
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${await tokenService(token, dispatch)}`
            };

            const response = await axios.get(GET_SIP_SELLER_DATA, { headers });
            return response?.data; // Return the response data to the component if needed
        } catch (error) {
            showNotification(compileErrors(error.response?.data.error), 'error');
        }
        finally {
            dispatch(startLoading(false));
        }
    };
};

// Add more actions for other API calls as needed
